import plugin from 'tailwindcss/plugin'

const tailwindConfig = {
  content: [
    './pages/**/*.{js,ts,jsx,tsx}',
    './components/**/*.{js,ts,jsx,tsx}',
    './rfxv1/**/*.{js,ts,jsx,tsx}',
    './pro/**/*.{js,ts,jsx,tsx}',
  ],
  theme: {
    fontFamily: {
      number: ['var(--font-number)'],
      body: ['var(--font-number)'],
    },
    extend: {
      animation: {
        marquee: 'marquee 25s linear infinite',
        marquee2: 'marquee2 25s linear infinite',
      },
      boxShadow: {
        bottomBar: '0px -4px 8px -1px rgba(0,0,0,0.2)',
        'primary-color':
          '0px 0px 14.6px 0px #1D897A, 0px 0px 133.266px 0px #1D897A',
      },
      colors: {
        black: '#000',
        'recentTrade-toggle': '#B8B8B8',

        heatmap: {
          first: '#3D0B51',
          second: '#53A884',
          third: '#F2A540',
        },

        patek: {
          hyper: '#51D2C1',
          shade: {
            white: '#FFFFFF',
            black: '#000000',
          },
          brand: {
            primary: '#1D897A',
            icon: '#A5A8FF',
          },
          primary: {
            'celestial-blue': {
              50: '#E1E2FF',
              100: '#D2D3FF',
              200: '#C3C5FF',
              300: '#B4B6FF',
              400: '#A5A8FF',
              500: '#9699FF',
              600: '#878BFF',
              700: '#787CFF',
              800: '#1D897A',
              900: '#5E63E5',
            },
          },
          neutral: {
            'celestial-grey': {
              50: '#FAFAFA',
              100: '#F8F9FA',
              200: '#E9ECEF',
              300: '#DEE2E6',
              400: '#CED4DA',
              500: '#ADB5BD',
              600: '#6C757D',
              700: '#495057',
              800: '#343A40',
              900: '#1A1A1A',
              1000: '#111113',
            },
          },
          greyscale: {
            'text-primary': '#FFFFFF',
            'text-secondary': '#FFFFFFB2',
            'grey-secondary': '#909096',
            'grey-territory': '#56565A',
            'grey-darker': '#212121',
          },
          border: {
            primary: '#343A40',
            secondary: '#343A40',
          },
          success: {
            primary: '#4BF2A1',
            secondary: '#141F1D',
            'celestial-green': {
              50: '#EDFFF6',
              100: '#C5FFE3',
              200: '#9EFFD0',
              300: '#76FFBD',
              400: '#4BF2A1',
              500: '#33D084',
              600: '#1FAE69',
              700: '#108C50',
              800: '#056A39',
              900: '#004825',
              1000: '#012413',
            },
          },
          error: {
            primary: '#DD4C4F',
            secondary: '#311919',
            'celestial-red': {
              50: '#FFEFEF',
              100: '#FFCCCD',
              200: '#FFA8AA',
              300: '#FF8588',
              400: '#FF6265',
              500: '#DD4C4F',
              600: '#BB393B',
              700: '#99282A',
              800: '#771A1C',
              900: '#550F11',
              1000: '#340102',
            },
          },
          warning: {
            primary: '#FF9C24',
            'celestial-yellow': {
              50: '#FFF6EF',
              100: '#FEEDDF',
              200: '#FEE3CF',
              300: '#FEDABF',
              400: '#FDD1AF',
              500: '#FDBE8F',
              600: '#FCAC6E',
              700: '#FCA35E',
              800: '#FB903E',
              900: '#FA7E1E',
            },
          },
          background: {
            'surface-primary': '#000000',
            'surface-secondary': '#1A1A1A',
            'surface-highlight': '#1A1A1A',
            'surface-grey': '#404040',
            'surface-modal': '#09090A',
            'bkg-6': '#212121',
          },
          button: {
            DEFAULT: '#FFFFFF',
            hover: '#FFFFFF',
          },
        },

        stargazer: {
          hyper: '#51D2C1',
          shade: {
            white: '#FFFFFF',
            black: '#000000',
          },
          brand: {
            primary: '#1D897A',
            icon: '#A5A8FF',
          },
          primary: {
            'celestial-blue': {
              50: '#E1E2FF',
              100: '#D2D3FF',
              200: '#C3C5FF',
              300: '#B4B6FF',
              400: '#A5A8FF',
              500: '#9699FF',
              600: '#878BFF',
              700: '#787CFF',
              800: '#1D897A',
              900: '#5E63E5',
            },
          },
          neutral: {
            'celestial-grey': {
              50: '#FAFAFA',
              100: '#F8F9FA',
              200: '#E9ECEF',
              300: '#DEE2E6',
              400: '#CED4DA',
              500: '#ADB5BD',
              600: '#6C757D',
              700: '#495057',
              800: '#343A40',
              900: '#1A1A1A',
              1000: '#111113',
            },
          },
          greyscale: {
            'text-primary': '#FFFFFF',
            'text-secondary': '#FFFFFFB2',
            'grey-secondary': '#909096',
            'grey-territory': '#56565A',
          },
          border: {
            primary: '#343A40',
            secondary: '#FFFFFF0D',
          },
          success: {
            primary: '#00E100',
            secondary: '#141F1D',
            'celestial-green': {
              50: '#EDFFF6',
              100: '#C5FFE3',
              200: '#9EFFD0',
              300: '#76FFBD',
              400: '#4BF2A1',
              500: '#33D084',
              600: '#1FAE69',
              700: '#108C50',
              800: '#056A39',
              900: '#004825',
              1000: '#012413',
            },
          },
          error: {
            primary: '#EF323F',
            secondary: '#21080D',
            'celestial-red': {
              50: '#FFEFEF',
              100: '#FFCCCD',
              200: '#FFA8AA',
              300: '#FF8588',
              400: '#FF6265',
              500: '#DD4C4F',
              600: '#BB393B',
              700: '#99282A',
              800: '#771A1C',
              900: '#550F11',
              1000: '#340102',
            },
          },
          warning: {
            primary: '#E78129',
            'celestial-yellow': {
              50: '#FFF6EF',
              100: '#FEEDDF',
              200: '#FEE3CF',
              300: '#FEDABF',
              400: '#FDD1AF',
              500: '#FDBE8F',
              600: '#FCAC6E',
              700: '#FCA35E',
              800: '#FB903E',
              900: '#FA7E1E',
            },
          },
          background: {
            'surface-primary': '#000000',
            'surface-secondary': '#262527',
            'surface-highlight': '#1A191B',
            'surface-grey': '#404040',
            'surface-modal': '#09090A',
          },
          button: {
            DEFAULT: '#FFFFFF',
            hover: '#FFFFFF',
          },
        },

        'th-bkg-1': 'var(--bkg-1)',
        'th-bkg-2': 'var(--bkg-2)',
        'th-bkg-3': 'var(--bkg-3)',
        'th-bkg-4': 'var(--bkg-4)',
        'th-bkg-5': 'var(--bkg-5)',
        'th-bkg-6': 'var(--bkg-6)',
        'th-fgd-1': 'var(--fgd-1)',
        'th-fgd-2': 'var(--fgd-2)',
        'th-fgd-3': 'var(--fgd-3)',
        'th-fgd-4': 'var(--fgd-4)',
        'th-fgd-5': 'var(--fgd-5)',
        'th-active': 'var(--active)',
        'th-active-icon': 'var(--active-icon)',
        'th-error': 'var(--error)',
        'th-error-secondary': 'var(--error-secondary)',
        'th-success': 'var(--success)',
        'th-success-secondary': 'var(--success-secondary)',
        'th-warning': 'var(--warning)',
        'th-down': 'var(--down)',
        'th-down-dark': 'var(--down-dark)',
        'th-up': 'var(--up)',
        'th-up-dark': 'var(--up-dark)',
        'th-button': 'var(--button)',
        'th-button-hover': 'var(--button-hover)',
        'th-input-bkg': 'var(--input-bkg)',
        'th-input-border': 'var(--input-border)',
        'th-input-border-secondary': 'var(--input-border-secondary)',
        'th-input-border-hover': 'var(--input-border-hover)',
      },
      backgroundImage: {
        'heatmap-bullish': `linear-gradient(180deg, #6ED5A3 0%, rgba(52, 103, 76, 0.46) 53.72%, rgba(1, 7, 0, 0.00) 100%)`,
        'heatmap-slightly-bullish': `linear-gradient(180deg, rgba(110, 213, 163, 0.20) 0%, rgba(52, 103, 76, 0.09) 53.72%, rgba(1, 7, 0, 0.00) 100%)`,
        'heatmap-slightly-bearish': `linear-gradient(180deg, rgba(213, 110, 110, 0.20) 0%, rgba(0, 0, 0, 0.00) 100%)`,
        'heatmap-bearish': `linear-gradient(180deg, #D56E6E 0%, rgba(0, 0, 0, 0.00) 100%)`,
      },
      fontSize: {
        xxs: '.65rem',
      },
      keyframes: {
        marquee: {
          '0%': { transform: 'translateX(0%)' },
          '100%': { transform: 'translateX(-100%)' },
        },
        marquee2: {
          '0%': { transform: 'translateX(100%)' },
          '100%': { transform: 'translateX(0%)' },
        },
        shimmer: {
          '100%': {
            transform: 'translateX(100%)',
          },
        },
      },
      screens: {
        '1.5xl': '1408px',
        fhd: '1920px',
        '2xl': '2000px',
      },
    },
  },
  plugins: [
    plugin(function ({ addComponents }) {
      addComponents({
        '.modal-glass': {
          /* Background/Modal/Glass */
          background:
            'linear-gradient(180deg, rgba(98, 106, 136, 0.1) 0%, rgba(46, 49, 73, 0.1) 100%)',
        },
        '.graph-error': {
          /* Red/Graph/Error */
          background:
            'linear-gradient(180deg, rgba(213, 110, 110, 0.20) 0%, rgba(0, 0, 0, 0.00) 100%)',
        },
        '.graph-success': {
          /* Green/Graph/Success */
          background:
            'linear-gradient(180deg, rgba(110, 213, 163, 0.20) 0%, rgba(52, 103, 76, 0.09) 53.72%, rgba(1, 7, 0, 0.00) 100%)',
        },
        '.gradient-logo': {
          /* Main/Gradient/Logo */
          background:
            'linear-gradient(214deg, #AEB1FD 10.94%, #AEB1FD 10.95%, #0E14C8 114.39%)',
        },
      })
    }),
  ],
}

export default tailwindConfig
